<template>
    <div>
        <transition-group
            enter-active-class="transition-opacity ease-linear duration-300"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity ease-linear duration-300"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
            tag="span"
        >
            <slot v-bind:filteredGradeLevels="filteredGradeLevels"></slot>
        </transition-group>
        <div v-show="show === false">
            <button @click="showAll" type="button">
                <svg
                    class="w-10 h-10 text-indigo-300"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        gradeLevels: {
            required: true,
            type: Array,
        },
        userGradeLevels: {
            required: false,
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            show: false,
        };
    },
    methods: {
        showAll() {
            this.show = true;
        },
    },
    computed: {
        filteredGradeLevels: function () {
            if (this.userGradeLevels.length === 0) {
                return this.gradeLevels;
            }
            if (this.show === true) {
                return this.gradeLevels;
            }

            return this.gradeLevels
                .filter((g) => this.userGradeLevels.includes(g.id))
                .filter((g) => g.groups.length > 0);
        },
        totalGroupsCount: function () {
            return this.gradeLevels.flatMap((gl) => gl.groups).length;
        },
        filteredGroupsCount: function () {
            return this.filteredGradeLevels.flatMap((gl) => gl.groups).length;
        },
    },
    mounted() {
        if (this.userGradeLevels.length === 0) {
            this.show = true;
        }
        if (this.filteredGroupsCount === this.totalGroupsCount) {
            this.show = true;
        }
        if (this.filteredGroupsCount === 0) {
            this.show = true;
        }
    },
};
</script>
